export const environment = {
  production: false,
  apiUrl: 'https://misfacturacionapitest.clavisco.com/',
  LogRocketId: ''
};
